export const VIDEO = 'VIDEO';
export const AUDIO = 'AUDIO';
export const AUDIO_EXTERNAL = 'AUDIO_EXTERNAL';
export const CHAT = 'CHAT';
export const NONE = 'NONE';
export const FACE_TO_FACE = 'FACE_TO_FACE';

export const CONVERSATION_TYPES = {
  [VIDEO]: {
    id: 'General.Video',
    defaultMessage: '** Video',
  },
  [AUDIO]: {
    id: 'General.Audio',
    defaultMessage: '** Audio',
  },
  [AUDIO_EXTERNAL]: {
    id: 'General.AudioExternal',
    defaultMessage: '** Audio External',
  },
  [CHAT]: {
    id: 'General.Chat',
    defaultMessage: '** Chat',
  },
  [NONE]: {
    id: 'General.None',
    defaultMessage: '** None',
  },
  [FACE_TO_FACE]: {
    id: 'Conversations.ConversationType.FaceToFace',
    defaultMessage: '** Face to Face',
  },
};

export const conversationTypes = [VIDEO, AUDIO_EXTERNAL, FACE_TO_FACE];
